import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken, clearAuth } from '../utils/auth.util';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const token = getToken();

  if (!token) {
    clearAuth();
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
